const USER_ADMIN_PERMISSION_CODES: string[] = [
  'add_nivosuser',
  'change_nivosuser',
  'delete_nivosuser',
  'view_nivosuser'
]

const NEWS_ADMIN_PERMISSION_CODES: string[] = [
  'add_notification',
  'change_notification',
  'delete_notification',
  'view_notification'
]

const INCIDENT_REPORT_ADMIN_PERMISSION_CODES: string[] = [
  'add_incidentreport',
  'change_incidentreport',
  'delete_incidentreport',
  'view_incidentreport'
]

const AMENITY_ADMIN_PERMISSION_CODES: string[] = [
  'add_amenity',
  'change_amenity',
  'delete_amenity',
  'view_amenity'
]

const DOCUMENT_FILE_ADMIN_PERMISSION_CODES: string[] = [
  'add_file',
  'change_file',
  'delete_file',
  'view_file'
]

const DOCUMENT_FOLDER_ADMIN_PERMISSION_CODES: string[] = [
  'add_folder',
  'change_folder',
  'delete_folder',
  'view_folder'
]

const SUPER_ADMIN = USER_ADMIN_PERMISSION_CODES.concat(
  NEWS_ADMIN_PERMISSION_CODES,
  INCIDENT_REPORT_ADMIN_PERMISSION_CODES
)

export {
  USER_ADMIN_PERMISSION_CODES,
  NEWS_ADMIN_PERMISSION_CODES,
  INCIDENT_REPORT_ADMIN_PERMISSION_CODES,
  AMENITY_ADMIN_PERMISSION_CODES,
  DOCUMENT_FILE_ADMIN_PERMISSION_CODES,
  DOCUMENT_FOLDER_ADMIN_PERMISSION_CODES,
  SUPER_ADMIN
}
